import type { ProgressColor, ProgressSize } from './types';

/** Maps a progress colour to its fill background class. Shared by both progress bars. */
export const progressFillColorClass = (color: ProgressColor) =>
  cva('', {
    variants: {
      color: {
        lime: 'bg-secondary',
        coral: 'bg-brand-coral',
        pink: 'bg-brand-pink',
        purple: 'bg-brand-purple',
        orange: 'bg-brand-orange',
        blue: 'bg-brand-blue',
        yellow: 'bg-brand-yellow',
        success: 'bg-success',
        error: 'bg-destructive',
      },
    },
  })({ color });

/**
 * The track/wrapper classes keyed by size, `sm` is a flat strip, `md`/`lg` the rounded
 * recessed bar.
 */
export const progressTrackClass = (size: ProgressSize) =>
  twMerge(
    cva('relative w-full overflow-hidden', {
      variants: {
        size: {
          sm: 'h-3 rounded-full bg-muted',
          md: 'h-6 rounded-2xl bg-background border-2 border-white inset-shadow-[0_1px_2px_rgb(0_0_0/0.12)]',
          lg: 'h-8 rounded-2xl bg-background border-2 border-white inset-shadow-[0_1px_2px_rgb(0_0_0/0.12)]',
        },
      },
    })({ size }),
  );

/** The glossy highlight overlay classes keyed by size. The flat `sm` strip has no gloss. */
export const progressGlossClass = (size: ProgressSize) =>
  twMerge(
    cva('absolute rounded-full pointer-events-none', {
      variants: {
        size: {
          sm: 'hidden',
          md: 'left-1 right-1 top-0.5 h-1',
          lg: 'left-2 right-2 top-0.5 h-2.5',
        },
      },
    })({ size }),
  );
